module.exports = __webpack_public_path__ + "static/media/bowen-38.a3872ae7.jpg";